// Same backend sort keys the Unit table uses (event-history-table.controller.js `ctrl.reversed`).
export const EVENT_SORT_KEYS = {
  ACTIVATED: 'ACTIVATED',
  EVENT_ID: 'EVENT_ID',
  TITLE: 'TITLE',
  ACTION: 'ACTION',
};

export const defaultEnvironmentColumns = ['force event cleared', 'car type', 'unit number', 'force event occured'];

export const DEFAULT_VISIBLE_ENVIRONMENT_COLUMNS = new Set([
  'unit number',
  'car type',
  'additional parameter 1',
]);

export const environmentColumnLabels = {
  'force event cleared': 'Force Event Cleared',
  'car type': 'Car Type',
  'unit number': 'Unit Number',
  'force event occured': 'Force Event Occurred',
};

export const getEnvironmentColumns = selectedEnvData =>
  (selectedEnvData?.length ? selectedEnvData : defaultEnvironmentColumns).map(column => ({
    accessorKey: column,
    header: environmentColumnLabels[column] || column,
  }));

export const toChildRow = (event, environmentColumns, formatTimestamp) => ({
  consist: event.consist,
  car: event.carNumber,
  timestamp: formatTimestamp(event.activated),
  eventId: event.eventId || event.eventHexCode,
  name: event.name || '-',
  action: event.action || '-',
  ...environmentColumns.reduce((values, column) => ({
    ...values,
    [column.accessorKey]: event.environmentData?.[column.accessorKey] || '-',
  }), {}),
});

export const formatCarCount = count => `${count} ${count === 1 ? 'Car' : 'Cars'}`;
